import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import FPAToolkit from "./components/FPAToolkit";
import { ArticlesPage } from "./pages/ArticlesPage";
import { ArticleDetailPage } from "./pages/ArticleDetailPage";
import { ApproachPage } from "./pages/ApproachPage";
import { ContactPage } from "./pages/ContactPage";
import { DisclaimerPage } from "./pages/DisclaimerPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { FreeResourcesPage } from "./pages/FreeResourcesPage";
import { PresentationsPage } from "./pages/PresentationsPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminAmazingReadsPage } from "./pages/AdminAmazingReadsPage";
import { HiringPlannerApp } from "./pages/HiringPlannerApp";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/approach" element={<ApproachPage />} />
          <Route path="/free-resources" element={<FreeResourcesPage />} />
          <Route path="/presentations" element={<PresentationsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/amazing-reads" element={<AdminAmazingReadsPage />} />
          <Route path="/calculators" element={<FPAToolkit />} />
          <Route path="/calculators/hiring-planner/*" element={<HiringPlannerApp />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:slug" element={<ArticleDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
